import "./Modal.css";
import Confetti from "react-confetti";

const Modal = ({ setModal, CONTRACT_ADDRESS, mint }) => {
  return (
    <div className="modalBackground">
      <Confetti />
      <div className="modalContainer">
        <div className="titleCloseBtn">
          <button
            onClick={() => {
              setModal(false);
            }}
          >
            X
          </button>
        </div>
        <div className="title">
          <h3>Congratulations on Minting your .bird ENS</h3>
        </div>
        <div className="body">
          <p>It will be updated shortly available on opensea</p>
        </div>
        <div className="footer">
          <button
            onClick={() => {
              setModal(false);
            }}
            className="cta-button  mint-button"
          >
            <a
              //
              //   href={`https://testnets.opensea.io/assets/mumbai/${CONTRACT_ADDRESS}/${mint}`}
              //   target="_blank"
              //   className="cta-button  mint-button"
              style={{
                textDecoration: "none",
                color: "white",
              }}
            >
              Yes!
            </a>
          </button>

          <button
            onClick={() => {
              setModal(false);
            }}
            className=""
            id="cancelBtn"
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
